import {} from 'containers'
import { connectNetwork } from 'lib/NetworkProvider'
import { routes, route_from } from 'lib/routes'
import View from 'lib/View'
import moment from 'moment-with-locales-es6'
import React, { Component } from 'react'
import Moment from 'react-moment'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { Button, Card, Icon, Input, Table } from 'semantic-ui-react'
import { floatTimeToString, formatMoney, getAmount, timeString } from '../lib/util'
import { Confirmation } from '../components'

const { app, products: productRoute, productEdit } = routes

moment.locale('it')
Moment.globalMoment = moment
Moment.globalLocale = 'it'

class Product extends Component {
    constructor(props) {
        super(props)

        let { onCostChange, product } = props

        this.state = {
            colors: ['red', 'orange', 'yellow', 'olive', 'green', 'teal', 'blue', 'violet', 'purple', 'pink', 'brown', 'grey', 'black'],
            deleting: false,
            ...product,
            productMinutes: product ? parseFloat(product.productMinutes) : 0,
        }

        if (onCostChange && product) {
            onCostChange(this.totalCost(), product.code)
        }
    }

    totalCost() {
        let { productHourlyRate, productHours, productMinutes } = this.state
        let total = (productHours + productMinutes / 60) * parseFloat(productHourlyRate)
        if (isNaN(total)) {
            total = 0
        }
        return total
    }

    componentDidMount() {
        let { product, code, network } = this.props

        if ((!product || !product.code) && code) {
            network.getProduct(code)
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        let { onCostChange, getProduct, login } = this.props
        let { code, productHourlyRate } = this.state
        if (productHourlyRate !== prevState.productHourlyRate) {
            if (onCostChange) {
                onCostChange(this.totalCost(), code)
            }
        }

        console.log('Product getProduct fetching', getProduct.fetching)
        if (getProduct && getProduct.fetching !== prevProps.getProduct.fetching && !getProduct.fetching) {
            console.log('Done calling getProduct')
            if (getProduct.status.success) {
                console.log(getProduct.data)
                let product = getProduct.data.data

                this.setState({ ...product })
                console.log('Calling Get product', login, product)
                /*
				if (login && login.data.user && login.data.user.companies) {
					let company = login.data.user.companies[organization.data[0]]
					console.log('Calling getFromIdFiltering', company, jobId)
					network.getFromIdFiltering(company, jobId, [
						{
							key: 'timestamp',
							symbol: '>',
							value: moment().subtract(4, 'hours').format('YYYY-MM-DD HH:mm:ss')
						}
					])
				}*/
                return
            } else {
                console.log('calling No product found with this id')
            }
        }
    }

    renderBalanceFooter() {
        let { hourtotal, total } = this.props

        let averageHourlyCost = Math.round((total / hourtotal) * 100) / 100
        if (isNaN(averageHourlyCost)) {
            averageHourlyCost = '--'
        }

        return (
            <Table.Row>
                <Table.Cell width="5">Prezzo orario medio: {averageHourlyCost}€/h</Table.Cell>
                <Table.Cell style={{ textAlign: 'right' }} width="4">
                    Totale Ore:
                </Table.Cell>
                <Table.Cell width="4">{floatTimeToString(hourtotal)}</Table.Cell>
                <Table.Cell width="1">Totale:</Table.Cell>
                <Table.Cell width="2">{total}€</Table.Cell>
            </Table.Row>
        )
    }

    renderBalanceHeader() {
        return (
            <Table.Header fullWidth>
                <Table.Row>
                    <Table.HeaderCell width="5">Nome Macchina</Table.HeaderCell>
                    <Table.HeaderCell width="4">Prezzo €/h</Table.HeaderCell>
                    <Table.HeaderCell width="4">Ore di lavoro</Table.HeaderCell>
                    <Table.HeaderCell width="1" />
                    <Table.HeaderCell width="2">Totale</Table.HeaderCell>
                </Table.Row>
            </Table.Header>
        )
    }

    renderForBalance() {
        let { code, productHourlyRate, productHours, productMinutes } = this.state
        return (
            <Table.Row>
                <Table.Cell>{code}</Table.Cell>
                <Table.Cell>
                    <span className="no-print">
                        <Input
                            type="number"
                            step="0.01"
                            value={productHourlyRate}
                            onChange={(e, data) => {
                                let value = data.value
                                if (value < 0) value = 0
                                this.setState({
                                    productHourlyRate: value,
                                })
                            }}
                        />
                        €/h
                    </span>
                    <span className="only-print">{productHourlyRate}€/h</span>
                </Table.Cell>
                <Table.Cell>{timeString(productHours, productMinutes)}</Table.Cell>
                <Table.Cell>=</Table.Cell>
                <Table.Cell>{this.totalCost()}€</Table.Cell>
            </Table.Row>
        )
    }

    renderTableFooter() {
        let { isBalance } = this.props
        if (isBalance) return this.renderBalanceFooter()
        else return null
    }

    renderTableHeader() {
        let { hideProduct, hideProductHours, isBalance } = this.props
        if (isBalance) {
            return this.renderBalanceHeader()
        } else {
            return (
                <Table.Header fullWidth>
                    <Table.Row>
                        {!hideProduct && <Table.HeaderCell>Nome Macchina</Table.HeaderCell>}
                        {!hideProductHours && <Table.HeaderCell>Ore di lavoro</Table.HeaderCell>}
                    </Table.Row>
                </Table.Header>
            )
        }
    }

    renderForTable() {
        let { hideProduct, hideProductHours, isBalance } = this.props
        let { code, productHours, productMinutes } = this.state

        if (isBalance) {
            return this.renderForBalance()
        } else {
            return (
                <Table.Row>
                    {!hideProduct && <Table.Cell>{code}</Table.Cell>}
                    {!hideProductHours && <Table.Cell>{timeString(productHours, productMinutes)}</Table.Cell>}
                </Table.Row>
            )
        }
    }

    openRemoveDialog() {
        this.setState({ deleting: true })
    }

    remove() {
        let { network } = this.props
        let { code } = this.state

        network.deleteProduct(code)

        this.setState({ deleting: false })
    }

    render() {
        let { login, type, product, onClick, selected, noActions } = this.props
        let {
            deleting,
            code,
            corpName,
            categoryName,
            description,
            price,
            categoryDiscount,
            corpDiscount,
            // productImage,
        } = this.state

        let extraprops = {
            fluid: type === 'full' ? true : false,
        }

        if (onClick) {
            extraprops.onClick = () => {
                onClick(product)
            }
        }

        let col = parseInt(Math.random() * this.state.colors.length)

        if (product && product.code === 1) {
            return null
        }

        let user = null
        if (login && login.authenticated) {
            user = login.data.user
        }

        switch (type) {
            case 'footer':
                return this.renderTableFooter()
            case 'header':
                return this.renderTableHeader()
            case 'table':
                return this.renderForTable()

            default:
                return (
                    <Card className={selected ? 'rowSelected' : ''} style={styles.productCard} {...extraprops} color={this.state.colors[col]}>
                        <Confirmation
                            message="Vuoi davvero eliminare questo prodotto?"
                            showModal={deleting}
                            onConfirm={() => {
                                this.remove()
                            }}
                            onCancel={() => {
                                this.setState({ deleting: false })
                            }}
                        />
                        <Card.Content>
                            <Card.Header>{description}</Card.Header>
                            <View between>
                                <Card.Meta>{code}</Card.Meta>
                                <Card.Meta>{categoryName}</Card.Meta>
                                <Card.Meta style={{ textTransform: 'capitalize' }}>{corpName}</Card.Meta>
                            </View>
                            <View style={{ paddingTop: 8 }}>
                                <View>
                                    <Card.Description>Intero &nbsp;</Card.Description>
                                    <Card.Meta> {formatMoney(price)}€</Card.Meta>
                                </View>
                                <View style={{ paddingLeft: 18 }}>
                                    <Card.Description>Base &nbsp;</Card.Description>
                                    <Card.Meta>{formatMoney(getAmount(price, 1, `${categoryDiscount} + ${corpDiscount}`))}€</Card.Meta>
                                </View>
                            </View>
                        </Card.Content>
                        {!noActions && (
                            <Card.Content extra>
                                {user && !!user.manage_product && (
                                    <Button
                                        color="blue"
                                        onClick={() => {
                                            console.log('Going to', app, productRoute, productEdit, code)
                                            this.props.history.push(route_from(app, productRoute, productEdit, `${code}`))
                                        }}
                                    >
                                        <Icon name="edit" />
                                        Modifica
                                    </Button>
                                )}
                                {user && !!user.manage_product && (
                                    <Button
                                        color="red"
                                        onClick={() => {
                                            this.openRemoveDialog()
                                        }}
                                    >
                                        <Icon name="delete" />
                                        Elimina
                                    </Button>
                                )}
                            </Card.Content>
                        )}
                    </Card>
                )
            // return (
            // 	<View fullw column between>
            // 		<Card
            // 			className={selected ? 'rowSelected' : ''}
            // 			style={styles.productCard}
            // 			{...extraprops}
            // 			color={this.state.colors[col]}>
            // 			<Confirmation
            // 				message='Vuoi davvero eliminare questo prodotto?'
            // 				showModal={deleting}
            // 				onConfirm={() => {
            // 					this.remove()
            // 				}}
            // 				onCancel={() => {
            // 					this.setState({ deleting: false })
            // 				}}
            // 			/>
            // 			<Card.Content style={styles.productContent}>
            // 				<View fullw row>
            // 					{/* <div style={styles.imageContainer}>
            // 						<ImageDefault
            // 							fromRoot
            // 							src={productImage}
            // 							ui={false}
            // 							style={styles.productImage}
            // 						/>
            // 					</div> */}
            // 					<View fullw column>
            // 						<span style={styles.header}>{description}</span>

            // 						<Card.Description>{code}</Card.Description>
            // 						<Card.Description>{corpName}</Card.Description>
            // 						<Card.Description>{categoryName}</Card.Description>
            // 						<Card.Description>{price}€</Card.Description>
            // 						<Card.Description>
            // 							{moment(date_created).format('DD/MM/YYYY HH:mm:ss')}
            // 						</Card.Description>
            // 					</View>
            // 				</View>
            // 			</Card.Content>
            // 			{!noActions && (
            // 				<Card.Content extra>
            // 					<Button
            // 						color='blue'
            // 						disabled={true}
            // 						onClick={() => {
            // 							this.props.history.push(route_from(app, product, productEdit, `${code}`))
            // 						}}>
            // 						<Icon name='edit' />
            // 						Modifica
            // 					</Button>
            // 					<Button
            // 						color='red'
            // 						disabled={true}
            // 						onClick={() => {
            // 							this.openRemoveDialog()
            // 						}}>
            // 						<Icon name='delete' />
            // 						Elimina
            // 					</Button>
            // 				</Card.Content>
            // 			)}
            // 		</Card>
            // 	</View>
            // )
        }
    }
}

const styles = {
    header: {
        fontSize: '32pt',
        lineHeight: 'normal',
    },
    imageContainer: {
        width: 200,
        height: 150,
        marginRight: 28,
    },
    productImage: {
        width: 200,
        height: 150,
        objectFit: 'contain',
    },
    productContent: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    productCard: {
        marginTop: 8,
        marginBottom: 8,
    },
}

const mapStateToProps = (state) => {
    let { login, getProduct } = state
    let rcode = null
    if (login && login.data && login.data.user) rcode = login.data.user.rcode

    return { role: rcode, getProduct, login }
}

export default withRouter(connect(mapStateToProps)(connectNetwork(Product)))
